import { observer } from 'mobx-react';
import React from 'react';
import placementTestsPerLevelChartService from '../../services/PlacementTestsPerLevelChartService';
import PlacementTestsPerLevelChart from './PlacementTestsPerLevelChart';

function GlobalPlacementTestsPerLevelChartContainer() {
  return (
    <PlacementTestsPerLevelChart
      data={placementTestsPerLevelChartService.data}
      isFetching={placementTestsPerLevelChartService.fetch.fetching}
    />
  );
}

export default observer(GlobalPlacementTestsPerLevelChartContainer);
